import { render, staticRenderFns } from "./activeBank.vue?vue&type=template&id=8ff41f92&scoped=true"
import script from "./activeBank.vue?vue&type=script&lang=js"
export * from "./activeBank.vue?vue&type=script&lang=js"
import style0 from "./activeBank.vue?vue&type=style&index=0&id=8ff41f92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ff41f92",
  null
  
)

export default component.exports